const hbQuickAddTimers = new WeakMap();

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.hb-product-card__quick-form');
  if (!form) return;
  event.preventDefault();
  // Guard the form, not only the button: keyboard/programmatic submits can repeat.
  if (form.dataset.submitting === 'true') return;
  const button = form.querySelector('.hb-product-card__quick-add');
  const label = button?.querySelector('span');
  const card = form.closest('.hb-product-card');
  const status = card?.querySelector('[data-hb-quick-add-status]');
  clearTimeout(hbQuickAddTimers.get(form));
  form.dataset.submitting = 'true';
  form.setAttribute('aria-busy', 'true');
  if (button) button.disabled = true;
  if (label) label.textContent = 'Adding…';
  if (status) status.hidden = true;

  /** @param {string} message @param {string} state */
  const setStatus = (message, state) => {
    if (!status) return;
    status.textContent = message;
    status.dataset.state = state;
    status.hidden = false;
  };

  try {
    const formData = new FormData(form);
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData,
    });
    const data = await res.json();
    if (!res.ok || data.status) {
      throw new Error(data.description || 'Could not add item. Please try again.');
    }

    const image = form.dataset.image;
    const cartIcon = document.querySelector('.header-actions__cart-icon');
    if (image && cartIcon && button) {
      const flyEl = document.createElement('fly-to-cart');
      flyEl.classList.add('fly-to-cart--quick');
      flyEl.style.setProperty('background-image', `url(${image})`);
      flyEl.style.setProperty('--start-opacity', '0');
      flyEl.source = button;
      flyEl.destination = cartIcon;
      document.body.appendChild(flyEl);
    }
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: {},
        sourceId: formData.get('id'),
        data: { source: 'product-form-component', itemCount: 1 },
      },
    }));
    if (label) label.textContent = 'Added to cart';
    setStatus('Added to cart.', 'success');
    hbQuickAddTimers.set(form, setTimeout(() => {
      if (label) label.textContent = 'Add to cart';
      if (status) status.hidden = true;
    }, 1800));
  } catch (err) {
    console.error('Quick add failed:', err);
    if (label) label.textContent = 'Add to cart';
    // Leave errors visible until the buyer retries.
    setStatus(err instanceof Error ? err.message : 'Could not add item. Please try again.', 'error');
  } finally {
    delete form.dataset.submitting;
    form.removeAttribute('aria-busy');
    if (button) button.disabled = false;
  }
});
